/* ============================================================
   Vintage Luxe Up — shared front-end effects
   - data-vlu-reveal: IntersectionObserver entrance animations.
     Adds [data-vlu-revealed] when the element first enters viewport.
   - [data-vlu-slider]: enhances horizontal snap-scroll rails with
     prev/next arrow controls and a position counter ("01 / N").
   ============================================================ */
(function () {
  'use strict';

  // ---------- Reveal-on-scroll ----------

  function initReveal() {
    const targets = document.querySelectorAll('[data-vlu-reveal]:not([data-vlu-revealed])');
    if (!targets.length || !('IntersectionObserver' in window)) {
      // Reduced-motion / no-JS fallback: just reveal immediately.
      targets.forEach((el) => el.setAttribute('data-vlu-revealed', ''));
      return;
    }

    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.setAttribute('data-vlu-revealed', '');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.15 });

    targets.forEach((el) => io.observe(el));
  }

  // ---------- Slider rails ----------

  function initSliders() {
    document.querySelectorAll('[data-vlu-slider]').forEach((slider) => {
      const rail = slider.querySelector('[data-vlu-slider-rail]');
      const prev = slider.querySelector('[data-vlu-slider-prev]');
      const next = slider.querySelector('[data-vlu-slider-next]');
      const counterCurrent = slider.querySelector('[data-vlu-slider-current]');
      const counterTotal = slider.querySelector('[data-vlu-slider-total]');
      if (!rail) return;

      const items = Array.from(rail.children);
      if (counterTotal) counterTotal.textContent = String(items.length).padStart(2, '0');

      function step() {
        // Page = roughly the visible portion of the rail.
        return rail.clientWidth * 0.85;
      }

      function updateCounter() {
        if (!counterCurrent) return;
        // Find the first item whose left edge is at or after rail.scrollLeft.
        const x = rail.scrollLeft;
        let idx = 0;
        for (let i = 0; i < items.length; i++) {
          if (items[i].offsetLeft <= x + 8) idx = i;
        }
        counterCurrent.textContent = String(idx + 1).padStart(2, '0');
        if (prev) prev.disabled = x <= 4;
        if (next) next.disabled = x + rail.clientWidth >= rail.scrollWidth - 4;
      }

      function scrollBy(dir) {
        rail.scrollBy({ left: dir * step(), behavior: 'smooth' });
      }

      if (prev) prev.addEventListener('click', () => scrollBy(-1));
      if (next) next.addEventListener('click', () => scrollBy(1));

      let raf = null;
      rail.addEventListener('scroll', () => {
        if (raf) return;
        raf = requestAnimationFrame(() => { updateCounter(); raf = null; });
      }, { passive: true });

      window.addEventListener('resize', updateCounter, { passive: true });
      updateCounter();
    });
  }

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  ready(() => {
    initReveal();
    initSliders();
  });
})();
